var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 89,
    viewBox: "0 0 91 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 43C91 67.8528 69.8528 89 45 89C20.1472 89 0 72.8528 0 48C0 23.1472 13.1472 0 38 0C62.8528 0 91 18.1472 91 43Z",
    fill: "#f64444ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.255 35C29.0096 35 28 36.0096 28 37.255V58.8385C28 60.0839 29.0096 61.0935 30.255 61.0935H60.5364C61.7818 61.0935 62.7914 60.0839 62.7914 58.8385V37.255C62.7914 36.0096 61.7818 35 60.5364 35H30.255ZM31.3809 37.5781H59.4086C60.043 37.5781 60.2955 38.3984 59.7709 38.7551L46.3005 47.915C45.7539 48.2867 45.0357 48.2867 44.489 47.915L31.0186 38.7551C30.494 38.3984 30.7465 37.5781 31.3809 37.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.519aab936f357615c01e9303d5f774c5.svg";
export { ForwardRef as ReactComponent };